import {
    Alert,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Row,
    TextArea
} from "design-react-kit";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { properties } from "../../../config/properties";
const styles = {
    formContainer: {
        padding: '2rem',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        border: '1px solid #ddd'
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem' // Spazio tra i pulsanti
    }
};
const InserimentoDelega = ({user}) => {

    const [descrizione, setDescrizione] = useState('');
    const [note, setNote] = useState('');
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const closeAlert = () => setOpen(false);

    const handleConferma = async (e) => {
        e.preventDefault(); // blocca reload del form

        try {
            const response = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/add/deleghe",
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ descrizione, note, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente })
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                setError("Errore di comunicazione con il server.");
                setOpen(true);
                return ;

            }

            if (!response.ok) {
                setError("Errore nella chiamata al serverf");
                setOpen(true);
                return;
            }

            const result = await response.json();

            if (result.esito === "OK") {
                navigate('/private/elencoDeleghe', { state: { esito: result } });
            } else {
                setError("Operazione fallita");
                setOpen(true);

            }

        } catch (err) {
            setError("Errore di rete o server non raggiungibile");
            setOpen(true);
        }
    };

    return (
        <Container className="bg-white py-5 py-lg-6">
            <div className="bg-white py-5 py-lg-6">
                <Row className="justify-content-center">
                    <Col md={8} lg={8}>
                        <div style={styles.formContainer}>
                            <h2 style={styles.formTitle}>
                                Inserimento nuova Tipologia di delega
                            </h2>


                            {error && open && (
                                <Alert color="danger" isOpen={open} toggle={closeAlert} className="mb-4">
                                    <strong>Attenzione:</strong> {error}
                                </Alert>
                            )}

                                <form onSubmit={handleConferma}>
                                    <Row>
                                        <TextArea
                                            id="descrizione"
                                            label="Inserisci Delega"
                                            value={descrizione}
                                            onChange={(e) => setDescrizione(e.target.value)}
                                            rows={5}
                                            required={true}
                                            maxLength={500}
                                        />
                                    </Row>

                                    <Row>
                                        <TextArea
                                            id="note"
                                            label="Inserisci note"
                                            value={note}
                                            onChange={(e) => setNote(e.target.value)}
                                            rows={5}
                                            maxLength={500}
                                        />
                                    </Row>

                                    <Row className="mt-3">
                                        <Col sm="auto">
                                            <Button
                                                className="btn btn-outline-secondary"
                                                outline
                                                type="button"
                                                onClick={() => navigate('/private/elencoDeleghe')}
                                            >
                                                Annulla
                                            </Button>
                                        </Col>
                                        <Col sm="auto">
                                            <Button
                                                className="btn btn-outline-primary"
                                                type="submit"
                                            >
                                                Conferma
                                            </Button>
                                        </Col>
                                    </Row>
                                </form>
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    );
};

export default InserimentoDelega;
